/**
 * A brief full-screen red vignette flashed when the LOCAL player takes damage — the classic MMORPG
 * "ouch" screen pulse. One reused fixed overlay; each call snaps it bright then fades it out.
 */

let el: HTMLDivElement | null = null;
let timer = 0;

function ensure(): HTMLDivElement {
  if (el) return el;
  el = document.createElement("div");
  el.style.cssText = [
    "position:fixed", "inset:0", "pointer-events:none", "z-index:9000", "opacity:0",
    // a soft red darkening that hugs the screen edges (centre stays clear)
    "background:radial-gradient(ellipse at center, rgba(150,0,0,0) 42%, rgba(165,8,8,0.6) 100%)",
  ].join(";");
  document.body.appendChild(el);
  return el;
}

/** Flash the hurt vignette. `intensity` (0..1) scales the peak opacity for bigger hits. */
export function flashHurt(intensity = 1): void {
  const e = ensure();
  e.style.transition = "opacity 45ms ease-out";
  e.style.opacity = String(Math.min(0.85, 0.42 + 0.45 * Math.max(0, Math.min(1, intensity))));
  window.clearTimeout(timer);
  timer = window.setTimeout(() => {
    e.style.transition = "opacity 340ms ease-in";
    e.style.opacity = "0";
  }, 70);
}
